/**
 * CWR 2.2 — presentational SVG icons for the catalog, copied verbatim from the
 * confirmed mockup (book-session-catalog.html). All decorative (`aria-hidden`).
 */
import type { ReactElement } from 'react';
import type { HubServiceDto } from '@/api/types';

export const PinIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <path d="M12 21s-7-4.3-7-10a7 7 0 0 1 14 0c0 5.7-7 10-7 10z" />
    <circle cx="12" cy="11" r="2.5" />
  </svg>
);

export const ScreenIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <rect x="2" y="5" width="14" height="14" rx="2" />
    <path d="m22 8-6 4 6 4z" />
  </svg>
);

/** service-by-phone: the By phone kind (docs/mockups/service-by-phone/). */
export const PhoneIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export const ClockIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const CheckIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const ArrowIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export const NoAvailIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

export const CalendarIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const BackIcon: ReactElement = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const MODALITY_ICON: Record<HubServiceDto['modality'], ReactElement> = {
  IN_PERSON: PinIcon,
  ONLINE: ScreenIcon,
  PHONE: PhoneIcon,
};

/** In person → pin; Online → screen; By phone → phone (matches the mockup meta-row icon). */
export function modalityIcon(modality: HubServiceDto['modality']): ReactElement {
  return MODALITY_ICON[modality];
}
